<template>
  <div class="Units">
    <div ref="wrapper">
      <div class="try_content" ref="content">
        <div
          class="swiper-slide"
          v-for="(unit, index) in this.package.units"
          :key="index"
          @mouseenter="unitMouseenter(unit, index)"
          @mouseleave="unitMouseenter(unit, -1)"
          :ref="'box' + index"
        >
          <div class="title">
            <h4>{{ unit.name.zh.split("|")[0] }}</h4>
            <h3>{{ unit.name.zh.split("|")[1] }}</h3>
          </div>

          <div class="content" v-show="showUnitContent == index">
            <!-- intro -->
            <div class="intro" v-if="unit.type == 'intro'">
              <div class="enter-info" @click="showIntro(unit)">
                <div class="video-left"></div>
                <p class="classname">先导课</p>
              </div>
              <div class="enter-info" @click="showChromeUrls(unit)">
                <div class="down-left"></div>
                <p class="classname">软件下载</p>
              </div>
              <div class="enter-info">
                <div class="check-left"></div>
                <p class="classname" @click="showTest">设备检测</p>
              </div>
            </div>
            <div class="intro2" v-if="unit.type == 'intro2'">
              <div class="enter-info" @click="showIntro2video1(unit)">
                <div class="video1-left"></div>
                <p class="classname">新手指导</p>
              </div>
              <div class="enter-info" @click="showIntro2video2(unit)">
                <div class="video2-left"></div>
                <p class="classname">先导故事</p>
              </div>
            </div>
            <!-- exam -->
            <div class="exam" v-if="unit.type == 'exam'">
              <div class="enter-info">
                <div class="exam-left"></div>
                <p class="classname" @click="showExam(unit)">进入测试</p>
                <!-- <div class="info-right"></div> -->
                <div
                  class="info-right"
                  v-if="showExamProgress(unit) == 2"
                ></div>
                <div
                  class="in-progress"
                  v-else-if="showExamProgress(unit) == 1"
                ></div>
              </div>
            </div>
            <!-- archived -->
            <div
              class="enter"
              v-if="unit.type == 'archived' || unit.type == 'scratch/archived'"
            >
              <div class="enter-info" @click="showVideo(unit)">
                <div class="video-left"></div>
                <p class="classname">视频互动课</p>
                <div
                  class="info-right"
                  v-if="unit.progress.video == 'completed'"
                ></div>
                <div
                  class="in-progress"
                  v-else-if="unit.progress.video == 'in-progress'"
                ></div>
              </div>
              <div class="enter-info" @click="showCourses1(unit)">
                <div class="scratch1-left"></div>
                <p class="classname">随堂作业</p>
                <div
                  class="info-right"
                  v-if="unit.progress.scratch1 == 'completed'"
                ></div>
                <div
                  class="in-progress"
                  v-else-if="unit.progress.scratch1 == 'in-progress'"
                ></div>
              </div>
              <div class="enter-info" @click="showCourses2(unit)">
                <div class="scratch2-left"></div>
                <p class="classname">课后挑战</p>
                <div
                  class="info-right"
                  v-if="unit.progress.scratch2 == 'completed'"
                ></div>
                <div
                  class="in-progress"
                  v-else-if="unit.progress.scratch2 == 'in-progress'"
                ></div>
              </div>
              <ul
                class="download"
                :class="{
                  'download-active': unit.progress.video !== 'completed',
                }"
              >
                <li @click="unitDownload(unit, 0)">讲义下载</li>
                <li @click="unitDownload(unit, 1)">课堂预习</li>
              </ul>
              <ul class="star" v-if="unit.progress">
                <li v-for="(item_s, index) in showStar(unit)" :key="index">
                  <img
                    :src="
                      item_s == 2
                        ? require('@/assets/images/star.png')
                        : require('@/assets/images/star-no.png')
                    "
                    alt
                  />
                </li>
              </ul>
            </div>
          </div>
          <div class="outline" v-show="showUnitContent != index">
            <div
              class="poster"
              :style="{ backgroundImage: 'url(' + unit.poster + ')' }"
            ></div>
            <ul class="star" v-if="unit.progress && !showClose(unit)">
              <li v-for="(item_s, index) in showStar(unit)" :key="index">
                <img
                  :src="
                    item_s == 2
                      ? require('@/assets/images/star.png')
                      : require('@/assets/images/star-no.png')
                  "
                  alt
                />
              </li>
            </ul>
          </div>

          <div class="unit-lock" v-show="showClose(unit)">
            <img src="~@/assets/images/lock.png" alt />
            <p class="show-day">{{ lockShowDay(unit) }}</p>
            <p class="show-time">{{ lockShowTime(unit) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
  props: {
    package: Object,
    serverDate: String,
  },
  data() {
    return {
      showUnitContent: -1,
      iframeSrc: "",
      lockRoles: true,
      swiperOptionHide: true,
      len: 0,
    };
  },
  mounted() {
    //根据角色显示解锁状态
    this.axios
      .get("/v1/api/self")
      .then((res) => {
        let roles = res.data.user.roles;
        if (roles && Array.isArray(roles)) {
          this.lockRoles =
            roles.includes("teacher") || roles.includes("classmanager")
              ? false
              : true;
        } else {
          this.lockRoles = true;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  watch: {
    package(val) {
      this.len = val.units.length;
      this.$nextTick(() => {
        if (!this.scroll) {
          let width = this.len * 300;
          this.$refs.content.style.width = width + "px";
          this.scroll = new BScroll(this.$refs.wrapper, {
            startX: 0,
            click: false,
            scrollX: true,
            preventDefault: false,
            scrollY: false,
            eventPassthrough: "vertical",
            disableMouse: false,
            disableTouch: false,
            deceleration: 0.009,
          });
        } else {
          this.scroll.refresh();
        }
      });
    },
  },
  methods: {
    showStar(unit) {
      let starList = [];
      if (unit.progress.video == "completed") {
        starList.push(2);
      } else {
        starList.push(1);
      }
      if (unit.progress.scratch1 == "completed") {
        starList.push(2);
      } else {
        starList.push(1);
      }
      if (unit.progress.scratch2 == "completed") {
        starList.push(2);
      } else {
        starList.push(1);
      }
      return starList.sort((n1, n2) => n2 - n1);
    },
    showTest() {
      this.$emit("showTest");
    },
    showExamProgress(unit) {
      let bool = unit.progress.every((item) => {
        return item === null;
      });
      let status = 0;
      if (bool) {
        //没有开始
        status = 0;
      } else {
        let bool2 = unit.progress.some((item) => {
          return item === null;
        });
        if (bool2) {
          //正在进行
          status = 1;
        } else {
          status = 2;
        }
      }
      return status;
    },
    unitDownload(unit, index) {
      if (unit.notes) {
        if (index === 0 && window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler("openPDF", unit.notes[index]);
          return;
        }
        window.open(unit.notes[index]);
      }
    },
    unitMouseenter(unit, index) {
      for (let i = 0; i < this.len; i++) {
        this.$refs["box" + i][0].style = "";
      }
      if (index === -1 || index === this.showUnitContent) {
        this.showUnitContent = -1;
        for (let i = 0; i < this.len; i++) {
          this.$refs["box" + i][0].style = "";
        }
      } else {
        setTimeout(() => {
          this.showUnitContent = index;
          for (let i = 0; i < this.len; i++) {
            this.$refs["box" + i][0].style = "";
          }
          this.$refs["box" + index][0].style.transform = "scale(1.14)";
          this.$refs["box" + index][0].style["box-shadow"] =
            "0px 2px 15px 0px rgba(27, 148, 239, 0.85)";
        }, 30);
      }
    },
    lockShowDay(unit) {
      if (unit.startDate) {
        let startDateO = new Date(unit.startDate);
        var weeks = ["日", "一", "二", "三", "四", "五", "六"];
        let startDate = `${
          startDateO.getMonth() + 1
        }月${startDateO.getDate()}日 周${weeks[startDateO.getDay()]}`;
        return startDate;
      }
    },
    toDouble(n) {
      return n < 10 ? "0" + n : n;
    },
    lockShowTime(unit) {
      if (unit.startDate) {
        let startDateO = new Date(unit.startDate);
        let startDate = `${this.toDouble(
          startDateO.getHours()
        )} : ${this.toDouble(startDateO.getMinutes())}`;
        return startDate;
      }
    },
    showClose(unit) {
      if (!this.lockRoles) {
        return false;
      }
      if (unit.startDate) {
        let currentTime = new Date(this.serverDate).getTime();
        // let currentTime = new Date().getTime();
        let unitTime = new Date(unit.startDate).getTime();
        let diffTime = unitTime - currentTime;
        // 2小时解锁
        let unlockTime = 1000 * 60 * 60 * 2;
        if (unitTime <= currentTime) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    showIntro(unit) {
      let iframeSrc = unit.videoUrl;
      window.open(iframeSrc);
      // this.$emit('showUserinfo');
    },
    showChromeUrls(unit) {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      var a = document.createElement("a");
      if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
        console.log("这是windows32位系统");
        a.href = unit.chromeUrls.win32;
      } else if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        console.log("这是windows64位系统");
        a.href = unit.chromeUrls.win64;
      } else if (agent.indexOf("windows nt 5") != -1) {
        console.log("这是XP系统");
        a.href = unit.chromeUrls.xp;
      } else if (isMac) {
        console.log("这是mac系统");
        a.href = unit.chromeUrls.mac;
      }
      a.click();
    },
    showExam(unit) {
      let src = `/package/${this.package._id}/unit/${unit._id}/course/${unit.courses[0].courseId}?exam=1`;
      window.open(src);
    },
    showVideo(unit) {
      console.log(unit);
      this.$router.push({
        path: "/video",
        query: {
          packageId: this.package._id,
          unitId: unit._id,
          coursesId: unit.courses[0].courseId,
        },
      });
    },
    showCourses1(unit) {
      let iframeSrc = `/package/${this.package._id}/unit/${unit._id}/course/${unit.courses[0].courseId}?level=lastscratch&type=work`;
      window.location.href = iframeSrc;
    },
    showCourses2(unit) {
      let iframeSrc = `/package/${this.package._id}/unit/${unit._id}/course/${unit.courses[1].courseId}?type=fighting`;
      // window.open(iframeSrc);
      window.location.href = iframeSrc;
    },
    showIntro2video1(unit) {
      window.open(unit.videoOne);
    },
    showIntro2video2(unit) {
      window.open(unit.videoTwo);
    },
  },
};
</script>

<style lang="stylus" scoped>
bgsize($u, $w = 100%, $h = 100%) {
  background: url('~@/assets/images/' + $u + '.png') no-repeat;
  background-size: $w $h;
}

.try_content {
  height: 100%;
  display: flex;
  padding: 0 30px;
}

.Units {
  height: 100%;
  position: relative;
}

.content {
  position: relative;

  .download-alert {
    width: 501px;
    height: 142px;
    background: rgba(0, 0, 0, 0.65);
    border-radius: 12px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      width: 350px;
      color: #fff;
      font-size: 25px;
      font-weight: bold;
      text-align: center;
    }

    img {
      width: 86px;
      height: 86px;
    }
  }
}

.swiper-container {
  padding: 45px 20px;
  margin: 0 40px;
  overflow: initial;

  /deep/ .swiper-pagination-bullets {
    bottom: 0px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 9px;
    height: 9px;
  }

  /deep/ .swiper-pagination-bullet-active {
    width: 26px;
    height: 9px;
    background: linear-gradient(90deg, rgba(254, 201, 63, 1) 0%, rgba(253, 170, 26, 1) 100%);
    border-radius: 10px;
  }
}

.swiper-button-prev {
  width: 50px;
  height: 110px;
  bgsize('left-btn');
  left: -40px;
  opacity: 1 !important;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
  }
}

.swiper-button-next {
  width: 50px;
  height: 110px;
  bgsize('right-btn');
  right: -40px;
  opacity: 1 !important;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.1);
  }
}

.swiper-slide {
  width: 250px !important;
  height: 345px;
  background: #1CCCFF;
  border-radius: 23px;
  margin-right: 40px;
  transition: transform 1s;
  overflow: hidden;
  position: relative;

  &:hover {
    transform: scale(1.14);
    box-shadow: 0px 2px 15px 0px rgba(27, 148, 239, 0.85);
  }

  .title {
    height: 95px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 2px 2px rgba(0, 73, 123, 0.6);
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h3 {
      font-size: 20px;
      padding: 0;
      margin: 0;
    }
  }

  .content {
    width: 240px;
    height: 245px;
    background: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 20px 20px;
    margin: 0 auto;
    margin-bottom: 20px;

    .intro {
      padding-top: 35px;

      .enter-info {
        width: 220px;
        height: 40px;
        background-color: #FFF4DC;
        box-shadow: 0px 3px 0px #D38700;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin: 0 11px 20px;
        cursor: pointer;

        .video-left {
          width: 16px;
          height: 16px;
          margin: 0 20px;
          bgsize('video-ico');
        }

        .down-left {
          width: 16px;
          height: 16px;
          margin: 0 20px;
          bgsize('down');
        }

        .check-left {
          width: 16px;
          height: 16px;
          margin: 0 20px;
          bgsize('check');
        }

        .classname {
          width: 110px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FDB422;
        }

        &:hover {
          background: linear-gradient(119deg, rgba(255, 214, 60, 1) 0%, rgba(253, 172, 28, 1) 100%);

          .classname {
            color: #FFFFFF;
            text-shadow: 0px 2px 2px rgba(213, 131, 0, 0.68);
          }

          .video-left {
            bgsize('video-ico-ok');
          }

          .down-left {
            bgsize('down1');
          }

          .check-left {
            bgsize('check1');
          }
        }
      }
    }

    .intro2 {
      padding-top: 35px;

      .enter-info {
        width: 220px;
        height: 40px;
        background-color: #FFF4DC;
        box-shadow: 0px 3px 0px #D38700;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin: 0 11px 20px;
        cursor: pointer;

        .video1-left {
          width: 16px;
          height: 16px;
          margin: 0 24px;
          bgsize('infro2-video1');
        }

        .video2-left {
          width: 22px;
          height: 14px;
          margin: 0 20px;
          bgsize('infro2-video2');
        }

        .classname {
          width: 110px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FDB422;
        }

        &:hover {
          background: linear-gradient(119deg, rgba(255, 214, 60, 1) 0%, rgba(253, 172, 28, 1) 100%);

          .classname {
            color: #FFFFFF;
            text-shadow: 0px 2px 2px rgba(213, 131, 0, 0.68);
          }

          .video1-left {
            bgsize('infro2-video11');
          }

          .video2-left {
            bgsize('infro2-video21');
          }
        }
      }
    }

    .exam {
      padding-top: 60px;

      .enter-info {
        width: 220px;
        height: 40px;
        background-color: #FFF4DC;
        box-shadow: 0px 3px 0px #D38700;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin: 0 11px 10px;
        cursor: pointer;

        .exam-left {
          width: 16px;
          height: 16px;
          margin: 0 20px;
          bgsize('exam');
        }

        .classname {
          width: 110px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FDB422;
        }

        .info-right {
          width: 30px;
          height: 26px;
          margin: 0 15px;
          bgsize('completed');
        }

        .in-progress {
          width: 8px;
          height: 8px;
          bgsize('in-progress');
          margin: 0 15px;
        }

        &:hover {
          background: linear-gradient(119deg, rgba(255, 214, 60, 1) 0%, rgba(253, 172, 28, 1) 100%);

          .classname {
            color: #FFFFFF;
            text-shadow: 0px 2px 2px rgba(213, 131, 0, 0.68);
          }

          .exam-left {
            bgsize('exam1');
          }

          .info-right {
            bgsize('completed-ok');
          }

          .in-progress {
            bgsize('in-progress-ok');
          }
        }
      }
    }

    .enter {
      padding-top: 12px;

      .enter-info {
        width: 220px;
        height: 40px;
        background-color: #FFF4DC;
        box-shadow: 0px 3px 0px #D38700;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin: 0 11px 10px;
        cursor: pointer;

        .info-left {
          width: 34px;
          height: 34px;
          padding: 0 15px;
        }

        .video-left {
          width: 16px;
          height: 16px;
          margin: 0 20px;
          bgsize('video-ico');
        }

        .scratch1-left {
          width: 16px;
          height: 16px;
          margin: 0 20px;
          bgsize('test1-ico');
        }

        .scratch2-left {
          width: 16px;
          height: 16px;
          margin: 0 20px;
          bgsize('test2-ico');
        }

        .classname {
          width: 110px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FDB422;
        }

        .info-right {
          width: 30px;
          height: 26px;
          margin: 0 15px;
          bgsize('completed');
        }

        .in-progress {
          width: 8px;
          height: 8px;
          bgsize('in-progress');
          margin: 0 15px;
        }

        &:hover {
          background: linear-gradient(119deg, rgba(255, 214, 60, 1) 0%, rgba(253, 172, 28, 1) 100%);

          .classname {
            color: #FFFFFF;
            text-shadow: 0px 2px 2px rgba(213, 131, 0, 0.68);
          }

          .video-left {
            bgsize('video-ico-ok');
          }

          .scratch1-left {
            bgsize('test1-ico-ok');
          }

          .scratch2-left {
            bgsize('test2-ico-ok');
          }

          .info-right {
            bgsize('completed-ok');
          }

          .in-progress {
            bgsize('in-progress-ok');
          }
        }
      }

      .download {
        font-size: 12px;
        font-weight: 500;
        color: rgba(197, 95, 0, 1);
        list-style: none;
        display: flex;
        align-items: center;
        padding-top: 10px;
        margin: 0;

        li:nth-child(1) {
          bgsize('download1', 12px, auto);
          background-position: 0 3px;
          padding-left: 20px;
          margin-right: 20px;
          margin-left: 40px;
          cursor: pointer;
        }

        li:nth-child(2) {
          bgsize('download2', 17px, auto);
          background-position: 0 3px;
          padding-left: 25px;
          cursor: pointer;
        }
      }

      .download-active {
        color: #838383;

        li:nth-child(1) {
          bgsize('download10', 12px, auto);
          background-position: 1px 3px;
        }

        li:nth-child(2) {
          bgsize('download20', 17px, auto);
          background-position: 1px 3px;
        }
      }
    }
  }

  .star {
    list-style: none;
    display: flex;
    align-items: center;
    padding: 0;
    width: 110px;
    margin: 0 auto;
    margin-top: 10px;

    li {
      margin-right: 10px;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  .unit-lock {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.58);
    border-radius: 23px;

    img {
      width: 47px;
      height: 50px;
      margin: 0 auto;
      margin-top: 138px;
      margin-bottom: 70px;
    }

    p {
      color: #fff;
      font-size: 18px;
      text-align: center;
    }
  }

  .outline {
    width: 240px;
    height: 245px;
    background: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 20px 20px;
    margin: 0 auto;
    position: relative;

    .poster {
      width: 100%;
      height: 100%;
      border-radius: 0px 0px 20px 20px;
      // background: url("~@/assets/aa/111.png") no-repeat;
      background-size: cover;
      background-repeat: no-repeat;
      // background-position: center center;
    }

    .star {
      position: absolute;
      left: 65px;
      bottom: 20px;
    }
  }
}
</style>
